'use client';
import { useEffect, useState } from 'react';
import { useSellCarNew, useWindowDimensions } from '@/hook';
import { useRouter } from 'next/navigation';
import Modal from '@/components/shared/modal.component';
import SellCarThankYou from './thank-you.component';
import { EInspectionType } from '@/types';
import SellCarMobileHeader from '../sell-car-mobile-header/sell-car-mobile-header.component';
import { DimensionsTargets } from '@/hook/use-window-width.hook';

const ThankYouPageSellCar = () => {
    const router = useRouter();
    const {
        getPath,
        clearForm,
        getRegion,
        getInspectionType,
        getFormRecieptForThankYouPage,
        getStepper,
    } = useSellCarNew();
    const path = getPath();
    const { width, IS_DESKTOP } = useWindowDimensions(
        DimensionsTargets.DESKTOP
    );
    const [open, setOpen] = useState(true);
    const region = getRegion();
    const inspectionType = getInspectionType();
    const receipt = getFormRecieptForThankYouPage();

    const getInspectionCase: () =>
        | 'case1'
        | 'case2'
        | 'case3'
        | 'caseNone'
        | 'caseWarehouseInspection' = () => {
        if (inspectionType === EInspectionType.WAREHOUSE && path === 'path1')
            return 'caseWarehouseInspection';
        if (region.serviceable) return 'case1';
        else if (!region.serviceable && region.warehouse) return 'case2';
        else if (
            !region.serviceable &&
            !region.warehouse &&
            (region.addressCity || region.smallArea)
        )
            return 'case3';
        else return 'caseNone';
    };
    const onClose = () => {
        router.back();
        clearForm();
    };
    useEffect(() => {
        if (!IS_DESKTOP) {
            const stepper = getStepper();
            if (stepper[0]?.value === '' || !stepper[0]?.value) {
                onClose();
            }
        }
    }, []);
    useEffect(() => {
        if (!open) {
            onClose();
        }
    }, [open]);
    return width > 0 ? (
        IS_DESKTOP ? (
            <Modal open={open} setOpen={setOpen}>
                <SellCarThankYou
                    path={path}
                    formData={receipt}
                    inspectionCase={getInspectionCase()}
                />
            </Modal>
        ) : (
            <>
                <SellCarMobileHeader thankyouReached={true} />
                <SellCarThankYou
                    path={path}
                    formData={receipt}
                    inspectionCase={getInspectionCase()}
                />
            </>
        )
    ) : (
        <></>
    );
};
export default ThankYouPageSellCar;
